module.exports = __webpack_public_path__ + "static/ISMS_ANAB_ISMS-AC_color_Number-32e633f8677872f95ae8de4ac19938ab.jpg";